// import React from "react";
// import { BrowserRouter, Routes, Route } from "react-router-dom";
// import LoginForm from "./components/LoginForm/loginForm";
// import AdminPage from "./pages/AdminPage/AdminPage";
// import VisitorPage from "./pages/VisitorPage/visitorPage";

// import { UserProvider } from "./context/UserContext";
// // import "./index.css";

// function App() {
//   return (
//     // <BrowserRouter>
//     //   <Routes>
//     //     <Route path="/" element={<LoginForm />} />
//     //     <Route path="/admin" element={<AdminPage  />} />
//     //     <Route path="/visitor" element={<VisitorPage />} />
//     //   </Routes>
//     // </BrowserRouter>


//     <UserProvider>
//       <BrowserRouter>
//         <Routes>
//           <Route path="/" element={<LoginForm />} />
//           <Route path="/admin" element={<AdminPage />} />
//           <Route path="/visitor" element={<VisitorPage />} />
//         </Routes>
//       </BrowserRouter>

      
//     </UserProvider>








//   );
// }

// export default App;
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LoginForm from "./components/LoginForm/loginForm";
import AdminPage from "./pages/AdminPage/AdminPage";
import VisitorPage from "./pages/VisitorPage/visitorPage";
import { UserProvider } from "./context/UserContext";
import ProtectedRoute from "./protected route/ProtectedRoute"; // 👈 اضافه کن

function App() {
  return (
    <UserProvider>
      <BrowserRouter>
        <Routes>
          {/* صفحه ورود */}
          <Route path="/" element={<LoginForm />} />

          {/* مسیر مخصوص مدیران */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute allowedRoles={["manager", "bowner"]}>
                <AdminPage />
              </ProtectedRoute>
            }
          />

          {/* مسیر مخصوص بازاریاب‌ها */}
          <Route
            path="/visitor"
            element={
              <ProtectedRoute allowedRoles={["marketer"]}>
                <VisitorPage />
              </ProtectedRoute>
            }
          />

          {/* مسیر در صورت دسترسی غیرمجاز */}
          <Route path="/unauthorized" element={<h2>🚫 دسترسی غیرمجاز</h2>} />
        </Routes>
      </BrowserRouter>
    </UserProvider>
  );
}

export default App;
